var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-rating',{attrs:{"background-color":_vm.color || 'indigo lighten-3',"color":_vm.color || 'indigo',"size":_vm.size || 15,"dense":""},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }